import { Pipe, PipeTransform, inject } from '@angular/core';
import { APP_IMAGE_BASE_URL } from 'src/app/app.config';

@Pipe({
  standalone: true,
  name: 'imageUrl'
})
export class ImageUrlPipe implements PipeTransform {
  private baseUrl = inject(APP_IMAGE_BASE_URL);
  private placeholder = 'assets/images/svgs/landscape-placeholder-svgrepo-com.svg';

  transform(path: string | null | undefined): string {
    return path ? this.baseUrl + path : this.placeholder;
  }
}
